export default __webpack_public_path__ + "static/media/retail-orange.22de6cfe.svg";